module.exports = __webpack_public_path__ + "static/img/stay-option-icon-fitness.2bc7235b.svg";